import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Expander, ExpanderLayout } from "@amzn/stencil-react-components/expander";
import { Avatar, AvatarSize } from "@amzn/stencil-react-components/avatar";
import React, { FC } from "react";
import { CampaignResponseForm } from "./campaign-response-form";
import { CampaignStatusChip } from "./campaign-status-chip";
import type { DirectReportStatus } from "@/services/hardware-self-service/hardware-self-service.types";

interface TeamCampaignsSectionProps {
  directReports: DirectReportStatus[];
  currentUsername: string;
}

export const TeamCampaignsSection: FC<TeamCampaignsSectionProps> = ({
  directReports,
  currentUsername,
}) => {
  if (directReports.length === 0) {
    return null;
  }

  return (
    <Col gridGap="S300">
      {directReports.map((report) => (
        <Expander
          key={report.username}
          titleText={report.username}
          renderTitle={() => (
            <Row gridGap="S300" alignItems="center">
              <Avatar
                username={report.username}
                size={AvatarSize.ExtraSmall}
                showUsername={false}
              />
              <Text>{report.username}</Text>
              {report.status.campaign && (
                <Text fontWeight="bold">{report.status.campaign.name}</Text>
              )}
              <CampaignStatusChip campaign={report.status.campaign} />
            </Row>
          )}
          layout={ExpanderLayout.Card}
        >
          <CampaignResponseForm
            campaign={report.status.campaign}
            assets={report.status.assets ?? []}
            existingResponses={report.status.responses ?? {}}
            login={report.username}
            currentUsername={currentUsername}
            scope={report.status.scope}
          />
        </Expander>
      ))}
    </Col>
  );
};
